/* eslint-disable react/jsx-no-target-blank */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TikTok } from 'react-tiktok';

import Icon from '../Icon';
import Loader from '../Loader';

/**
 * TikTokPlayer
 */

class TikTokPlayer extends Component {
  constructor(props) {
    super(props);

    /** Parameters */
    this.play = () => this.setState({ isPlaying: true });
    this.pause = () => this.setState({ isPlaying: false });
    this.paused = () => !this.state.isPlaying;
    this.togglePlayPause = () => this.setState({ isPlaying: !this.state.isPlaying });

    /** State */
    this.state = { isPlaying: this.props.play };

    /** Refs */
    this.element = React.createRef();
  }

  /**
   * Invoked after the component is mounted
   */
  componentDidMount() {
    //
  }

  render() {
    const elementClass = this.props?.className || 'tiktok-player';
    const countClass = this.props.count ? 'l-count' : '';
    return (
      <div ref={this.element} className={`${elementClass} ${countClass}`}>
        <div className="tiktok-player-player" style={{ backgroundImage: `url(${this.props.poster})` }}>
          {this.state.isPlaying ? (
            <>
              <TikTok url={this.props.url} />
              <Loader />
            </>
          ) : (
            <a
              className="tiktok-player-button tiktok-player-button-play"
              href={this.props.url}
              onClick={(event) => {
                event.preventDefault();
                this.play();
              }}
            >
              <Icon icon="play-round" layout="text-white" />
            </a>
          )}
        </div>
        {this.props.legend && <span className="tiktok-player-legend">{this.props.legend}</span>}
      </div>
    );
  }
}

TikTokPlayer.propTypes = {
  url: PropTypes.string.isRequired,
  poster: PropTypes.string,
  play: PropTypes.bool,
  legend: PropTypes.string,
  className: PropTypes.string,
  count: PropTypes.bool,
};

TikTokPlayer.defaultProps = {
  play: false,
};

export default TikTokPlayer;
